import React, { useRef } from 'react';
import { Button } from 'react-bootstrap';
import html2canvas from 'html2canvas';
import { ORDER_ID_LENGTH, ORDER_ID_PREFIX } from '../../constants/commonConstants';
import { OrderReceiptContent } from './OrderReceiptContent';

export default function CustomerReceipt({ customerName, orderCartData, orderTotal, orderId, date, deliType, discount, deliFee, serviceCharge, tipMoney }) {
    const hiddenRef = useRef();
    const printableTitle = `${ORDER_ID_PREFIX}-${String(orderId).padStart(ORDER_ID_LENGTH, '0')}`;

    // const handleDownloadAsImage = async () => {
    //     if (!hiddenRef.current) return;

    //     // Wait for next paint (in case layout/styling isn't ready)
    //     // setTimeout(async () => {
    //     const canvas = await html2canvas(hiddenRef.current, {
    //         scale: 2,
    //         useCORS: true,
    //     });

    //     const image = canvas.toDataURL('image/png');

    //     const link = document.createElement('a');
    //     link.href = image;
    //     link.download = `${printableTitle}.png`;
    //     link.click();
    //     // }, 300); // Adjust if needed
    // };


    // const handlePrint = () => {
    //     const printWindow = window.open('', '_blank', 'width=600,height=800');
    //     if (!printWindow) return;

    //     const content = hiddenRef.current.innerHTML;

    //     const fullHtml = `
    //         <html>
    //             <head>
    //                 <title>Receipt - ${printableTitle}</title>
    //                 <style>
    //                     @page { margin: 5mm 25mm; }
    //                     body { font-family: monospace; font-size: 12px; padding: 5mm; box-sizing: border-box; }
    //                     .orderPrintContent { word-break: break-word; border: 1px solid #ccc; padding: 5mm; width: 600px; margin: 0 auto; }
    //                     hr { border: none; border-top: 1px solid #ccc; }
    //                 </style>
    //             </head>
    //             <body>
    //                 ${content}
    //                 <script>
    //                     window.onload = function() {
    //                         window.print();
    //                         window.onafterprint = function () {
    //                             window.close();
    //                         };
    //                     }
    //                 </script>
    //             </body>
    //         </html>
    //     `;

    //     printWindow.document.open();
    //     printWindow.document.write(fullHtml);
    //     printWindow.document.close();
    // };

    const handlePreviewImageInNewTab = async () => {
        if (!hiddenRef.current) return;

        const canvas = await html2canvas(hiddenRef.current, {
            scale: 2,
            useCORS: true,
        });

        const image = canvas.toDataURL('image/png');

        const imageWindow = window.open();
        if (imageWindow) {
            imageWindow.document.write(`
            <html>
                <head>
                    <title>Receipt Preview - ${printableTitle}</title>
                    <style>
                        body { background: #f0f0f0; margin: 20px 0px; }
                        .order-receipt-preview { width: fit-content; margin: 0 auto; }
                        img { width: 600px; }
                    </style>
                </head>
                <body>
                    <div class="order-receipt-preview">
                    <img src="${image}" alt="Receipt Preview" />
                    </div>
                </body>
            </html>
        `);
        } else {
            alert('Popup blocked! Please allow popups for this site.');
        }
    };


    return (
        <>
            {/* <Button type='button' className="appBtn w-100" variant="primary" onClick={handlePrint}>Print Receipt</Button> */}
            {/* <Button type='button' className="appBtn w-100" variant="primary" onClick={handleDownloadAsImage}>Download Receipt</Button> */}

            <Button
                type="button"
                className="appBtn w-100"
                variant="success"
                onClick={handlePreviewImageInNewTab}
            >
                Preview Receipt
            </Button>


            {/* Hidden print area */}
            <div
                ref={hiddenRef}
                style={{
                    position: 'absolute',
                    bottom: 0,
                    left: '-9999px',
                    width: '600px',
                    background: 'white', // explicitly set background
                    color: 'black',      // explicit text color
                    padding: '10px',
                }}
            >
                <OrderReceiptContent
                    customerName={customerName}
                    orderCartData={orderCartData}
                    orderTotal={orderTotal}
                    orderId={orderId}
                    date={date}
                    deliType={deliType}
                    discount={discount}
                    deliFee={deliFee}
                    serviceCharge={serviceCharge}
                    tipMoney={tipMoney}
                />
            </div>
            <div style={{
                position: 'absolute',
                bottom: 0,
                left: '-9999px',
                width: '600px',
                background: 'white', // explicitly set background
                color: 'black',      // explicit text color
                padding: '10px',
            }}>

            </div>
        </>
    );
}